// DOM-specific JS should be done here
// see /boilerplate/src/js/browser.js for the import pattern

import select from 'dom-select';

export const Button = (el) => {
  const ui = {
    el,
    body: select('body', document),
  };

  const userMsg = 'Copied!';

  const handleCopy = async () => {
    // get current URL of the page
    const currentURL = window.location.href;
    const originalText = el.textContent;
    await navigator.clipboard.writeText(currentURL);
    el.textContent = userMsg;
    el.setAttribute('disabled', true);
    setTimeout(() => {
      el.textContent = originalText;
      el.removeAttribute('disabled');
    }, 2000);
  };

  const addEvents = () => {
    ui.el.addEventListener('click', () => {
      handleCopy();
    });
  }

  const init = () => {
    addEvents();
  };

  init();
};

export default Button;